import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import axios from 'axios';
import * as CONSTANTS from "../CONSTANTS";
import { useParams } from 'react-router-dom';
import AdminAnnisiteDetails from '../Components/widgets/AdminAnnisteDetails';
import ModalItem from '../Components/ModalItem';
import AdminGalleryUpdates from '../Components/widgets/AdminGalleryUpdates';
import AdminMemoryDripps from '../Components/widgets/AdminMemoryDripps';

function AnnisiteDetails() {

  const [showModal, setShowModal]                                     = useState(false);
  const {user}                                                        = useSelector((state) => state.auth);

  
  const params                                                        = useParams();
  const [currentAnnisite, setCurrentAnnisite]                         = useState(null);
  const [accountUser, setAccountUser]                                 = useState(null);
  const [activeOuterTab, setActiveOuterTab]                           = useState("general");

  const [processing, setProcessing]                                   = useState(false);
  const [updateAction, setUpdateAction]                               = useState(0);

  useEffect(() => {
    if(accountUser){
      setShowModal(true);
    }
  },[accountUser]);

  useEffect(() => {
    collectSingleAnnisiteDetails()
  },[updateAction])

  const collectSingleAnnisiteDetails = async () => {
    try{
      const res = await axios.get(CONSTANTS.API_URL +"annivites/current/index/" + params.id);
    
      setCurrentAnnisite(res.data);
    }catch(err){
      console.log(err);
    }
  }
  
  const handleSave = async (updatedData) => {
    try {

      setProcessing(true);
      const resultUpdate = {
        "id" : params.id,
        "content": {
          "spouseA"       : updatedData.spouseA,
          "weddingVowsA"  : updatedData.weddingVowsA,
          "spouseB"       : updatedData.spouseB,
          "weddingVowsB"  : updatedData.weddingVowsB,
          "contactName"   : updatedData.contactName,
          "contactEmail"  : updatedData.contactEmail,
          "contactPhone"  : updatedData.contactPhone,
          "weddingDate"   : updatedData.weddingDate,
          "weddingTime"   : updatedData.weddingTime,
          "weddingAddress" :{
            "address" : updatedData.weddingAddress.address,
          },
          "weddingOnviteMessage"   : updatedData.weddingOnviteMessage,
          "weddingAnniviteMessage" : updatedData.weddingAnniviteMessage,
          "onviteDetails": {
              "mainEventTitle" : updatedData.onviteDetails.mainEventTitle,
              "mainEventDate" :  updatedData.onviteDetails.mainEventDate,
              "mainAddress" :  updatedData.onviteDetails.mainAddress,
              "mainStart" :  updatedData.onviteDetails.mainStart,
              "mainEnd" :  updatedData.onviteDetails.mainEnd,
              "receptionDate":  updatedData.onviteDetails.receptionDate,
              "receptionAddress" :  updatedData.onviteDetails.receptionAddress,
              "receptionStart" :  updatedData.onviteDetails.receptionStart,
              "receptionEnd" :  updatedData.onviteDetails.receptionEnd,
          },
        }
      }

      
      const res = await axios.put(CONSTANTS.API_URL + "annivites/special-update/v1/event", resultUpdate, {
          headers: {
            token: "Bearer " + user.accessToken
          }
        });
        setProcessing(false);
        setCurrentAnnisite(res.data); // update state with fresh data      

      toast.success("Changes saved successfully ✅");
    } catch (error) {
      setProcessing(false);
      console.error(error);
      toast.error("Failed to save changes ❌");
    }
  };

  const handleAccountUser = async () => {
    try{
      setProcessing(true);
      //setAccountUser
      const res = await axios.get(CONSTANTS.API_URL +"users/find/" + currentAnnisite.userId);
      console.log(res.data)
      setAccountUser(res.data);
      setProcessing(false);
    }catch(err){
      setProcessing(false);
      console.log(err);
    }
  }

  return (
    <div className="card">
      <div className="card-body">
        {
          currentAnnisite !== null && (
            <div className="dash-layer">
              <div className="dash-top-layer">
                <div className="content-user">
                  Account Holder: {currentAnnisite.userName} <br/>
                  <button
                    className="btn btn-warning mt-3"
                    onClick={() => handleAccountUser()}
                    disabled={processing}>
                      {processing ? "Processing" : "View"} 
                  </button>
                </div>
                 <ModalItem 
                    show={showModal} 
                    onClose={() => setShowModal(false)} 
                    title="Current User"
                  >
                    <div className="body-content-part">
                       {
                        accountUser && (
                          <table className="table table-striped">
                            <tbody>
                              <tr>
                                <td>Name</td>
                                <td>:</td>
                                <td>{accountUser.name}</td>
                              </tr>
                               <tr>
                                <td>Surname</td>
                                <td>:</td>
                                <td>{accountUser.surname}</td>
                              </tr>
                               <tr>
                                <td>Email</td>
                                <td>:</td>
                                <td>{accountUser.email}</td>
                              </tr>
                              <tr>
                                <td>Phone</td>
                                <td>:</td>
                                <td>{accountUser.phone}</td>
                              </tr>
                            </tbody>
                          </table>
                        )
                       }
                    </div>
                 </ModalItem>
                {
                  currentAnnisite?.featureUrl.length > 1 && (
                    <div className="featured-block">
                      <img src={currentAnnisite?.featureUrl} alt="Featured image" className="img-hybrid-admin" />
                    </div>
                  )
                }
              </div>
              <div className="field-set-out">
                   <ul className="nav nav-tabs" id="annisiteOuterTabs" role="tablist">
                      
                      <li className="nav-item field-st" role="presentation">
                        <button
                          className={`nav-link ${activeOuterTab === "general" ? "active" : ""}`}
                          onClick={() => setActiveOuterTab("general")}
                        >
                          General Details
                        </button>
                      </li>
                      <li className="nav-item field-st" role="presentation">
                        <button
                          className={`nav-link ${activeOuterTab === "gallery" ? "active" : ""}`}
                          onClick={() => setActiveOuterTab("gallery")}
                        >
                          Gallery Details
                        </button>
                      </li>
                      <li className="nav-item field-st" role="presentation">
                        <button
                          className={`nav-link ${activeOuterTab === "dripps" ? "active" : ""}`}
                          onClick={() => setActiveOuterTab("dripps")}
                        >
                          Dripps Details
                        </button>
                      </li>
                    </ul>

                    <div className="card-back">
                        {
                          activeOuterTab === "general" && (
                            <div className="card-body edit-section">
                              <AdminAnnisiteDetails currentAnnisite={currentAnnisite} processing={processing} onSave={handleSave}/>
                            </div>
                          )
                        }
                        {
                          activeOuterTab === "gallery" && (
                            <div className="card-body edit-section">
                              <AdminGalleryUpdates 
                                currentAnnisite={currentAnnisite} 
                                setCurrentAnnisite={setCurrentAnnisite} 
                                user={user}
                                setUpdateAction={setUpdateAction} />
                            </div>
                          )
                        }
                        {
                          activeOuterTab === "dripps" && (
                            <div className="card-body edit-section">
                              <AdminMemoryDripps 
                                currentAnnisite={currentAnnisite} 
                                user={user}
                                setUpdateAction={setUpdateAction} />
                            </div>
                          )
                        }
                    </div>
              </div>
              
              
            </div>
          )
        }
      </div>
    </div>
  )
}

export default AnnisiteDetails